import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        evaluationGroup: '=',
        comparisonGroups: '=',
        sites: '=',
        classifiers: '=',
        forms: '=',
        company: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'evaluation.Plan 360 feedback' | translate }}</h1>
            <ul class="actions01">
                <li>
                    <a class="btn edit" ng-click="vm.edit()">
                        {{ 'evaluation.Edit general data' | translate }}
                    </a>
                </li>
                <li>
                    <a class="btn edit" ng-click="vm.editTranslations()">
                        {{ 'evaluation.Edit translations' | translate }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="form">
            <div class="row">
                <label class="label">{{ 'evaluation.Name' | translate }}</label>
                <div class="items">
                    <span class="text">{{ vm.evaluationGroup.name }}</span>
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'evaluation.Deadline' | translate }}</label>
                <div class="items">
                    <span class="text">{{ vm.MomentService.formatTimeStamp(vm.evaluationGroup.deadline) }}</span>
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'evaluation.Associated form' | translate }}</label>
                <div class="items">
                    <span class="text">{{ vm.evaluationGroup.form.activeI18n.name }}</span>
                </div>
            </div>
            <div class="row">
                <label class="label">
                    {{ 'evaluation.Introduction text' | translate }}
                    <small>{{ 'evaluation.introduction_text_refinement' | translate }}</small>
                </label>
                <div class="items">
                    <span class="text" ng-bind-html="vm.getIntroduction()"></span>
                </div>
            </div>
        </div>
        <evaluation-view-participants
            evaluation-group="vm.evaluationGroup"
            bulk-ids="vm.bulkIds"
            list="vm.list"
            show-send-notifications="vm.showSendNotifications"
            classifiers="vm.classifiers"
            sites="vm.sites"
        />
        <div class="form ng-scope">
            <div class="row inline">
                <label class="label">{{ 'general.Bulk actions' | translate }}</label>
                <div class="items">
                    <select ng-model="vm.action" class="form-control small">
                        <option ng-if="vm.isDeadlinePassed()" value="reports">{{ 'evaluation.Send report' | translate }}</option>
                        <option ng-if="!vm.isDeadlinePassed()" value="reminders">{{ 'evaluation.Send reminders' | translate }}</option>
                        <option ng-if="!vm.isDeadlinePassed()" value="notifications">{{ 'evaluation.Send initial notifications' | translate }}</option>
                    </select>
                    <button ng-click="vm.handleBulkAction()" class="btn bordered02">{{ 'general.Ok' | translate }}</button>
                </div>
            </div>
        </div>
        <div class="well" ng-if="vm.isDeadlinePassed() && vm.PrivilegeService.canView360Reports()">
            <h2>{{ 'evaluation.Summary reports' | translate }}</h2>
            <div class="form">
                <div class="row">
                  <label class="label">{{ 'evaluation.Report input (blue bar)' | translate }}</label>
                  <div class="items">
                    <select class="form-control"
                            ng-model="vm.siteId"
                            ng-options="site.id as site.name for site in vm.sites track by site.id">
                      <option value="">{{ vm.evaluationGroup.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <label class="label">{{ 'evaluation.Comparison value (red line)' | translate }}</label>
                  <div class="items">
                    <select class="form-control"
                            ng-model="vm.comparisonSiteId"
                            ng-options="site.id as site.name for site in vm.sites track by site.id">
                      <option value="0">-</option>
                      <option value="">{{ vm.evaluationGroup.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <label class="label">{{ 'evaluation.Previous results comparison feedbackgroup (grey bar)' | translate }}</label>
                  <div class="items">
                    <select class="form-control"
                            ng-model="vm.comparisonGuid"
                            ng-options="group.guid as group.name for group in vm.comparisonGroups track by group.guid">
                      <option value="">-</option>
                    </select>
                  </div>
                </div>
                <ul class="actions01">
                    <li><a class="btn bordered02"
                        target="_blank"
                        ng-click="vm.viewReport()"
                        href=""
                    >{{ 'evaluation.View summary report' | translate }}</a></li>
                </ul>
            </div>
        </div>
        <ul class="actions01">
            <li><a ui-sref="authorized.evaluation.list()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a></li>
        </ul>
    `
})
export default class {
    constructor ($rootScope, $state, $translate, $window, lodash, toastr, EVALUATION_STATUS_ENUM,
                 ModalService, EvaluationGroupResource, MomentService, PrivilegeService, EVALUATION_INTRODUCTION_PLACEHOLDER_ENUM) {
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$window = $window;
        this.$state = $state;
        this.lodash = lodash;
        this.toastr = toastr;
        this.MomentService = MomentService;
        this.EVALUATION_STATUS_ENUM = EVALUATION_STATUS_ENUM;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.EvaluationGroupResource = EvaluationGroupResource;
        this.EVALUATION_INTRODUCTION_PLACEHOLDER_ENUM = EVALUATION_INTRODUCTION_PLACEHOLDER_ENUM;
    }

    $onInit () {
        this.comparisonSiteId = '0';
        this.list = {};
        this.bulkIds = [];
        this.action = this.isDeadlinePassed() ? 'reports' : 'reminders';
        this.normalizeEvaluationGroupI18ns();
    }

    normalizeEvaluationGroupI18ns () {
        const { evaluationGroup, company } = this;

        if (!evaluationGroup.evaluationGroupI18ns) {
            evaluationGroup.evaluationGroupI18ns = {};
        }

        // Convert array to object if needed
        if (Array.isArray(evaluationGroup.evaluationGroupI18ns)) {
            const i18nArray = evaluationGroup.evaluationGroupI18ns;
            evaluationGroup.evaluationGroupI18ns = {};

            i18nArray.forEach(entry => {
                if (entry.language) {
                    evaluationGroup.evaluationGroupI18ns[entry.language] = {
                        introduction: entry.introduction || ''
                        // Add other fields if necessary
                    };
                }
            });
        }

        // Ensure default language exists
        const lang = company.defaultLanguage;
        if (!evaluationGroup.evaluationGroupI18ns[lang]) {
            evaluationGroup.evaluationGroupI18ns[lang] = { introduction: '' };
        }
    }

    isDeadlinePassed () {
        return this.MomentService.isPassedTimeStamp(this.evaluationGroup.deadline);
    }

    sendNotifications () {
        if (!this.bulkIds.length) {
            return;
        }

        const post = {
            groupId: this.evaluationGroup.id,
            evaluationIds: this.bulkIds
        };

        const message = this.$translate.instant('evaluationGroup.Please confirm sending feedback notifications');
        this.ModalService.confirm(message, 'medium').then(() => {
            this.EvaluationGroupResource.notificationNotify(post).$promise.then(() => {
                this.$rootScope.$emit('evaluation:reloadList');
                this.EvaluationGroupResource.get({
                    id: this.evaluationGroup.id,
                    expand: 'form,activeI18n,evaluationGroupI18ns'
                }).$promise.then((evaluationGroup) => {
                    this.evaluationGroup = evaluationGroup;
                    this.toastr.success(this.$translate.instant('evaluationGroup.Notifications sent'));
                });
            })
            .catch((response) => {
                this.toastr.error(response.data[0].message);
            });
        });
    }

    sendReports () {
        if (!this.bulkIds.length) {
            return;
        }

        const post = {
            groupId: this.evaluationGroup.id,
            evaluationIds: this.bulkIds
        };
        const message = this.$translate.instant(
            'evaluationGroup.Are you sure you wish to send reports to {users}?',
            { users: this.getUsers() }
        );
        this.ModalService.confirm(message, 'medium').then(() => {
            this.EvaluationGroupResource.reportNotify(post).$promise.then(() => {
                this.EvaluationGroupResource.get({
                    id: this.evaluationGroup.id,
                    expand: 'form,activeI18n,evaluationGroupI18ns'
                }).$promise.then((evaluationGroup) => {
                    this.evaluationGroup = evaluationGroup;
                    this.toastr.success(this.$translate.instant('evaluationGroup.Reports sent'));
                });
            })
            .catch((response) => {
                this.toastr.error(response.data[0].message);
            });
        });
    }

    sendReminders () {
        if (!this.bulkIds.length) {
            return;
        }

        const post = {
            groupId: this.evaluationGroup.id,
            evaluationIds: this.bulkIds
        };
        const message = this.$translate.instant(
            'evaluationGroup.Please confirm sending feedback reminders',
        );
        this.ModalService.confirm(message, 'medium').then(() => {
            this.EvaluationGroupResource.reminderNotify(post).$promise.then(() => {
                this.EvaluationGroupResource.get({
                    id: this.evaluationGroup.id,
                    expand: 'form,activeI18n,evaluationGroupI18ns'
                }).$promise.then((evaluationGroup) => {
                    this.evaluationGroup = evaluationGroup;
                    this.$rootScope.$emit('evaluation:reloadList');
                    this.toastr.success(this.$translate.instant('survey.Notifications sent'));
                });
            })
            .catch((response) => {
                this.toastr.error(response.data[0].message);
            });
        });
    }

    getUsers () {
        const validUsers = this.lodash.filter(this.list.items, (item) => this.lodash.includes(this.bulkIds, item.id));
        const users = this.lodash.map(validUsers, (item) => `${item.firstName} ${item.lastName}`);
        return users.join(', ');
    }

    handleBulkAction () {
        if (this.action === 'reports') {
            this.sendReports();
        }
        if (this.action === 'reminders') {
            this.sendReminders();
        }
        if (this.action === 'notifications') {
            this.sendNotifications();
        }
    }

    viewReport () {
        const { $window, $state, siteId, comparisonSiteId, comparisonGuid, evaluationGroup } = this;
        const params = {
            guid: evaluationGroup.guid
        };

        if (siteId) {
            params.siteId = siteId;
        }

        if (comparisonSiteId) {
            params.comparisonSiteId = comparisonSiteId;
        }

        if (comparisonGuid) {
            params.comparisonGuid = comparisonGuid;
        }
        $window.open($state.href('evaluation.report', params), '_blank');
    }

    edit () {
        const { evaluationGroup, forms, company } = this;
        return this.ModalService.open({
            template: `
                <modals-evaluation-edit
                    class="wrapper"
                    forms="vm.forms"
                    uib-modal-instance="vm.$uibModalInstance"
                    evaluation-group="vm.evaluationGroup"
                    company="vm.company"
                />
            `,
            controller ($uibModalInstance) {
                this.forms = forms;
                this.evaluationGroup = evaluationGroup;
                this.company = company;
                this.$uibModalInstance = $uibModalInstance;
            }
        }).then((updateGroup) => {
            this.evaluationGroup = updateGroup;
            this.$rootScope.$emit('evaluation:reloadList');
            this.toastr.success(this.$translate.instant('general.Changes saved'));
            this.action = this.isDeadlinePassed() ? 'reports' : 'reminders';
        });
    }

    getIntroduction () {
        const deadlinePlaceholder = this.EVALUATION_INTRODUCTION_PLACEHOLDER_ENUM.GROUP_DEADLINE;
        const deadline = this.MomentService.formatTimeStamp(this.evaluationGroup.deadline);
        const evaluationGroupI18n = this.evaluationGroup && this.evaluationGroup.activeI18n;

        if (!evaluationGroupI18n || !evaluationGroupI18n.introduction) {
            return '';
        }

        return this.lodash.replace(evaluationGroupI18n.introduction, new RegExp(deadlinePlaceholder, 'g'), deadline);
    }

    editTranslations () {
        const { evaluationGroup, company } = this;

        this.ModalService.open({
            size: 'xlarge',
            template: '<modals-evaluation-translation uib-modal-instance="vm.$uibModalInstance" evaluation-group="vm.evaluationGroup" company="vm.company"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.evaluationGroup = evaluationGroup;
                this.company = company;
            }
        }).then((updatedEvaluationGroup) => {
            this.evaluationGroup = updatedEvaluationGroup;
            this.toastr.success(this.$translate.instant('general.Changes saved'));
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/view/index.js